<!--
 * @Author: MX
 * @Date: 2020-08-03 11:36:59
 * @LastEditTime: 2024-09-18 14:46:07
 * @Description: 服务管理 - 快件跟踪
-->
<template>
  <div class="expressTracking main-wrap">
      <div class="track-left">
          <base-input-tag-new ref="inputTag" v-model="searchKey" :validate="inputTagValid" :addTagOnBlur="true" maxHeight="360px" class="cms-input-tag"></base-input-tag-new>
          <div class="track-left-btns">
            <el-button type="primary" class="b_reset h32" plain  @click="resetSearch">{{ $lang('清空') }}</el-button>
            <el-button type="primary" class="h32"  :loading="keyBtn" @click="searchFun">{{ $lang('立即查询') }}</el-button>
          </div>
      </div>
     <div class="track-right" >
         <el-collapse v-model="activeName" v-if="traceList.length > 0">
              <el-collapse-item v-for="(tag, $index) in traceList" :key="tag.id" :title="$lang('运单编号')+'：' + tag.keyword" :name="$index">
                <div v-if="tag.needPhoneVerify" class="last-phone-box">
                  <InputCode ref="InputCodeVue" @sendCaptcha="sendCaptcha" :focusIndex="$index" />
                  <div class="btn-box">
                    <el-button type="primary" class="h32" :loading="searchLoading" @click="searchFunItem" :disabled="!searchLoading">{{ $lang('确认') }}</el-button>
                  </div>
                </div>
                  <div class="track-right_item" v-else-if="tag.details&&tag.details.length > 0">
                        <el-steps direction="vertical" class="track-right_item_steps">
                            <el-step v-for="(item, index) in tag.details"
                                    :key="index"
                                    :class="[index === 0 ? 'isFirst':'']"
                                    :description="item.customerTracking">
                                    <template slot="title">
                                        <span > {{item.scanTime}}</span><span v-if="item.remark2 ==='1'" class="imgView" @click="preViewImg(tag.keyword)">{{$lang('查看图片')}}</span>
                                    </template>
                                     <template slot="icon">
                                        <span class="track-right_item_status"> {{item.status}}</span>
                                    </template>
                                    </el-step>
                        </el-steps>
                  </div>
                  <div v-else class="no-data">
                    {{ $lang('暂无数据') }}
                </div>
              </el-collapse-item>
         </el-collapse>
      </div>

          <ImageView v-show="preViewVisible" :initialIndex='preViewIndex' :urlList='urlList' :onClose='preViewClose'></ImageView>

  </div>
</template>

<script>
import { getDetailByWaybillNos, listImagePath, signedUrl, getLogisticsTracking } from '@api/module/customer'
import { RESPONSE_SUCCESS } from '@constants'
import ImageView from './components/ImageView.vue'
import InputCode from './components/InputCode.vue'
export default {
  name: 'ExpressTracking',
  components: { ImageView, InputCode },
  data() {
    return {
      isShowFirst: false,
      searchKey: [],
      searchKeyOld: [],
      traceList: [], // 物流跟踪list
      inputTagValid: 'orderName',
      orderIds: '',
      preViewVisible: false, // 是否展示预览
      preViewIndex: 0, // 当前预览设置
      keyBtn: false,
      urlList: [],
      activeName: 0,
      searchLoading: false
    }
  },
  mounted() {
    this.orderIds = this.$route.params.orderIds
    if (this.orderIds) {
      this.searchKey = this.orderIds.split(',')
      this.searchKeyOld = this.orderIds.split(',')
      this.searchFun()
    }
    const waybillId = this.$route.query.waybillId
    if (waybillId) {
      this.searchKey = waybillId.split(',')
      this.searchFun()
    }
  },
  activated() {
    const waybillId = this.$route.query.waybillId
    if (waybillId) {
      this.searchKey = waybillId.split(',')
      this.searchFun()
    }
  },
  watch: {

  },
  methods: {
    searchFunItem() {

    },
    async sendCaptcha(phone, i, cb) {
      try {
        const itemData = this.traceList[i]
        const params = {
          waybillNo: itemData.keyword,
          phoneVerify: phone
        }
        this.searchLoading = true
        const { code, data, msg } = await getLogisticsTracking(params)
        this.searchLoading = false
        if (code === RESPONSE_SUCCESS) {
          this.$set(this.traceList, i, data[0])
        } else {
          this.$message.error(msg)
          cb(true, msg)
        }
      } catch (err) {
        this.searchLoading = false
        console.log('🚀 ~ sendCaptcha ~ err:', err)
      }
    },
    // 重置搜索
    resetSearch() {
      this.searchKey = []
      this.searchKeyOld = []
      this.traceList = []
      this.$refs.inputTag.newTag = ''
      if (this.orderIds) this.$router.push({ path: `/redirect/expressTracking` })
    },
    clearData() {
      this.traceList = []
    },
    // 搜索
    searchFun() {
      const reqList = []
      if (!this.searchKey || this.searchKey.length === 0) return this.$message.warning(this.$lang('请输入单号'))
      if (this.searchKey.length > 10) return this.$message.warning(this.$lang('您查询的单号已超出10条'))
      //   const newArr = this.searchKey.filter(item => !this.searchKeyOld.some(ele => ele === item))// 单次只能查询10条数据
      //   if (newArr.length > 10) return this.$message.warning(this.$lang('单次只能查询10条数据'))
      //   this.searchKeyOld = this.searchKey.slice(0)
      this.searchKey.forEach(item => reqList.push(item))
      this.getOrderList(reqList)
    },
    // 查询单号
    async getOrderList(reqList) {
      // const params = { keywordList: reqList }
      this.keyBtn = true
      const { code, msg, data } = await getDetailByWaybillNos(reqList)
      this.keyBtn = false
      if (code !== RESPONSE_SUCCESS) return this.$message.warning(this.$lang(msg))
      this.traceList = data
    },
    // 手机号加*
    disposePhoneFun(num) {
      let start = ''
      let end = ''
      if (num) {
        start = num.toString().substring(0, 3)
        end = num.toString().substring(num.length - 4, num.length)
      }
      return start + '****' + end
    },
    // 查看图片
    async preViewImg(item) {
      console.log(item)
      const arrList = []
      arrList.push(item)
      const { code, msg, data } = await listImagePath(arrList)
      if (code !== RESPONSE_SUCCESS) return this.$message.warning(this.$lang(msg))
      const imgData = await signedUrl(data)
      if (imgData.code !== RESPONSE_SUCCESS) return this.$message.warning(this.$lang(imgData.msg))
      this.urlList = imgData.data
      this.preViewIndex = 0
      this.preViewVisible = true
    },

    /**
     * @description: 关闭预览
     */
    preViewClose() {
      this.preViewIndex = 0
      this.preViewVisible = false
    }
    // urlList() {
    //   // 预览图 url数组
    //   const urlArr = []
    //   if (this.list && this.list.length) {
    //     this.list.map(v => {
    //       urlArr.push(v.downloadUrl)
    //     })
    //     return urlArr
    //   } else {
    //     return urlArr
    //   }
    // }
  }
}
</script>

<style lang="scss" scoped>
.expressTracking{
    width: 100%;
    display: flex;
    flex-direction:row;
    .track-left{
        width: 390px;
        padding: 24px;
        box-sizing: border-box;
        .track-left-btns{
            float: right;
            margin-top: 16px;
        }
    }
    .b_reset{
        width: 88px;
    }
    .track-right {
        flex:1;
        border: 16px solid #EDEEF3;
        padding: 16px 24px;
        background: #fff;
        overflow: auto;
        .no-data {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
        .track-right_item{
                margin-left: 60px;
        }
        .imgView{
          margin-left: 40PX;
          color: #e60012;
        }
        .track-right_item_status{
            position: absolute;
            top: -9px;
            right: 0px;
            line-height: 24px;
            width: 70px;
        }
    }

}
</style>
<style lang="scss">
.expressTracking{
     .input-tag-container {
          float: left;
          width: 100% !important;
          height: 160px;
          .vue-input-tag-wrapper {
            height: 160px !important;
            box-sizing: border-box;
          }
    }
    .el-collapse {
            border-bottom: 0;
            border-top-color: transparent !important;
          .el-collapse-item {
               background: #F7F7F9;
                border: 1px solid #EEEEEE;
                border-radius: 8px;
                margin-bottom: 24px;
                padding: 5px 24px;
            .el-collapse-item__header {
                background: #F7F7F9;
                font-weight: 600;
                justify-content: flex-start;
                font-size: 16px;
                padding-bottom: 0;
                border: 0;
                &.is-active{
                    color: $--color-primary;
                }
            }

            .el-collapse-item__wrap{
                background: #F7F7F9;
                border: 0;
          }
            .el-collapse-item__arrow{
                margin-left: 16px;
            }
          }
     }
     .el-step{
             position: relative;
             .el-step__head{
                 display: flex;
                justify-content: center;
             }
             .el-step__icon{
                width: 4px;
                height: 4px;
                border-radius: 50%;
                border: 0;
                background: #DDDDDD;
                position: relative;
                margin-top: 9px;
          }
          .el-step__description {
              margin-bottom:12px;
          }
          .el-step__line{
              top: 20px;
          }
          &.isFirst{
              .track-right_item_status,.el-step__title,.el-step__description{
                  color: #333333;
              }
              .el-step__icon{
                  width: 8px;
                    height: 8px;
                    background: #51c419;
              }
             .track-right_item_status{
                 font-weight: bold;
              }
          }
     }
}

.last-phone-box {
  .btn-box {
    margin-top: 40px;
    text-align: center;
  }
}
</style>

